export enum Paginate {
  PER_PAGE = 100,
  PAGE_INDEX = 1,
  PAGE_COUNT = 0,
}
